import * as excel from 'exceljs';
import { Style, Fill, FillPattern } from 'exceljs';
import { XlsxWriter } from '../interfaces/xlsx-writer.interface';

export class XlsxInMemoryWriter implements XlsxWriter {
    workbook: excel.Workbook;
    worksheet: excel.Worksheet;

    constructor(sheetname = 'Report') {
        this.workbook = new excel.Workbook();
        this.worksheet = this.workbook.addWorksheet(sheetname);
    }

    writeColumns(
        columns: { header: string; key: string; width: number }[],
        setStyles?: (row: excel.Row, defaultCellStyle: Partial<Style>, defaultCellFill: Fill) => void,
    ): void {
        this.worksheet.columns = columns;
        const firstRow = this.worksheet.getRow(1);

        const defaultCellStyle: Partial<Style> = {
            font: {
                bold: true,
                color: { argb: 'FFFFFF' },
            },
            alignment: { horizontal: 'center' },
        };
        const defaultCellFill: FillPattern = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '134EF7' },
        };

        if (setStyles) {
            setStyles(firstRow, defaultCellStyle, defaultCellFill);
        } else {
            firstRow.eachCell(function (cell) {
                cell.style = { ...defaultCellStyle };
                cell.fill = { ...defaultCellFill };
            });
        }
    }

    writeRow(row: unknown[], cb?: (row: excel.Row) => void): void {
        const addedRow = this.worksheet.addRow(row);
        if (cb) {
            cb(addedRow);
        }
    }

    async getBuffer(): Promise<Buffer> {
        const buffer = await this.workbook.xlsx.writeBuffer();
        return Buffer.from(buffer);
    }

    async close(encoding: BufferEncoding = 'base64'): Promise<string> {
        const buffer = await this.workbook.xlsx.writeBuffer();
        return Buffer.from(buffer).toString(encoding);
    }
}
